import {getService} from "~/lib/services/services-manager";
import {PartnerClientDto} from "~/lib/models/app-settings";

const SAService = () => getService('server-app');

export async function getPartnerClients(): Promise<PartnerClientDto[]> {
  return (await SAService().get(`/admin-client/partner/clients`)).data.clients;
}

export async function hasClients(): Promise<boolean> {
  return (await SAService().get(`/admin-client/partner/has-client`)).data.hasClient;
}
